<ng-container cdkPortalOutlet></ng-container>

<div class="arrow" popoverArrow></div>

<!-- [style.left.px]="arrowLeft"
  [style.bottom.px]="arrowBottom"
  [style.right.px]="arrowRight" -->